"use client";

import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Casestudies() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const filters = [{
    id: "all",
    label: "All"
  }, {
    id: "resorts",
    label: "Resorts"
  }, {
    id: "boutique",
    label: "Boutique"
  }, {
    id: "business",
    label: "Business"
  }, {
    id: "luxury",
    label: "Luxury"
  }];
  const projects = [{
    id: 1,
    category: "resorts",
    industry: "Resort",
    title: "Maldives Island Resort Growth",
    description: "Achieved 40% revenue increase through dynamic OTA pricing strategies.",
    buildTime: "3 Months",
    pageSpeed: "99",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/maldives_resort_growth.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/maldives_resort_growth.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/maldives_resort_growth.png-wvc-sizes"
  }, {
    id: 2,
    category: "boutique",
    industry: "Boutique",
    title: "Thailand Heritage Boutique",
    description: "Optimized direct booking channels and reduced OTA dependency.",
    buildTime: "2 Months",
    pageSpeed: "97",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/thailand_boutique_growth.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/thailand_boutique_growth.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/thailand_boutique_growth.png-wvc-sizes"
  }, {
    id: 3,
    category: "luxury",
    industry: "Luxury",
    title: "India 5-Star Property Audit",
    description: "Comprehensive revenue audit identifying untapped market segments.",
    buildTime: "1 Month",
    pageSpeed: "100",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/india_luxury_audit.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/india_luxury_audit.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/india_luxury_audit.png-wvc-sizes"
  }, {
    id: 4,
    category: "business",
    industry: "Business",
    title: "UK Urban Hotel Optimization",
    description: "Implemented advanced tech stack for automated rate management.",
    buildTime: "4 Months",
    pageSpeed: "96",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/uk_business_hotel.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/uk_business_hotel.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/uk_business_hotel.webp-wvc-sizes"
  }, {
    id: 5,
    category: "resorts",
    industry: "Resort",
    title: "Zanzibar Eco-Lodge Success",
    description: "Strategic OTA listing optimization driving seasonal occupancy.",
    buildTime: "2 Months",
    pageSpeed: "98",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/zanzibar_eco_lodge.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/zanzibar_eco_lodge.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/zanzibar_eco_lodge.png-wvc-sizes"
  }, {
    id: 6,
    category: "luxury",
    industry: "Luxury",
    title: "Philippines Villa Revenue",
    description: "Data-driven forecasting to maximize RevPAR during peak seasons.",
    buildTime: "3 Months",
    pageSpeed: "98",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/philippines_villa_revenue.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/philippines_villa_revenue.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/philippines_villa_revenue.png-wvc-sizes"
  }];
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleProjects = activeFilter === "all" ? projects : projects.filter(p => p.category === activeFilter);
  return <section data-section-id="120" id="implementationcasestudies" className="relative overflow-hidden bg-background py-20 md:py-28 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-lg opacity-30 blur-3xl" style={{
      background: "radial-gradient(circle, var(--chart-1) 0%, transparent 70%)"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-lg opacity-25 blur-3xl" style={{
      background: "radial-gradient(circle, var(--chart-2) 0%, transparent 70%)"
    }} />

      <div className="container relative mx-auto px-4 md:px-8">
        {}
        <div ref={headerRef} className={`flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between transition-all duration-700 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="max-w-xl">
            <div className="mb-4 inline-flex items-center gap-2">
              <span className="h-px w-8 bg-foreground/30" />
              <span className="font-default text-xs font-medium uppercase tracking-widest text-muted-foreground">
                Success Stories
              </span>
            </div>
            <h2 className="font-default text-4xl font-semibold tracking-tight text-foreground sm:text-5xl md:text-6xl">
              Proven{" "}
              <span className="bg-clip-text text-transparent" style={{
              backgroundImage: "linear-gradient(90deg, var(--chart-1), var(--chart-2))"
            }}>
                results
              </span>
            </h2>
          </div>

          {}
          <div className="-mx-4 overflow-x-auto px-4 lg:mx-0 lg:px-0">
            <div className="inline-flex items-center gap-2 rounded-lg border border-border bg-card/60 p-1.5 backdrop-blur-sm">
              {filters.map((filter, i) => {
              const isActive = activeFilter === filter.id;
              return <Button key={filter.id} data-index={i} variant="ghost" size="sm" onClick={() => setActiveFilter(filter.id)} className={`rounded-md px-4 py-2 text-sm font-medium transition-all ${isActive ? "text-primary-foreground shadow-md hover:text-primary-foreground" : "text-muted-foreground hover:bg-accent hover:text-foreground"}`} style={isActive ? {
                backgroundImage: "linear-gradient(135deg, var(--chart-1), var(--chart-2))"
              } : undefined}>
                    {filter.label}
                  </Button>;
            })}
            </div>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 transition-all duration-700 ease-out ${gridVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {visibleProjects.map((project, i) => <div key={project.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-lg border border-border bg-card transition-all duration-500 hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg">
              {}
              <div className="relative aspect-video overflow-hidden">
                <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                {}
                <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-24" style={{
              background: "linear-gradient(to top, var(--card) 0%, transparent 100%)"
            }} />
                {}
                <div className="absolute right-4 top-4 translate-y-1 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <Link to="/ResourcesPage" className="inline-flex items-center gap-1.5 rounded-md bg-background/80 px-3 py-1.5 text-xs font-medium backdrop-blur-md">
                    <span className="bg-clip-text text-transparent" style={{
                  backgroundImage: "linear-gradient(90deg, var(--chart-1), var(--chart-2))"
                }}>
                      Read Case Study
                    </span>
                    <ArrowUpRight className="h-3.5 w-3.5" style={{
                  color: "var(--chart-2)"
                }} />
                  </Link>
                </div>
              </div>

              {}
              <div className="flex flex-1 flex-col p-6">
                <div className="mb-3 inline-flex w-fit items-center rounded-md border border-border bg-accent/40 px-2.5 py-1 text-xs font-medium uppercase tracking-wider text-muted-foreground">
                  {project.industry}
                </div>

                <h3 className="font-default text-xl font-semibold leading-snug text-foreground">
                  {project.title}
                </h3>

                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {project.description}
                </p>

                {}
                <div className="mt-6 grid grid-cols-2 gap-4 border-t border-border pt-5">
                  <div>
                    <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                      Timeline
                    </div>
                    <div className="mt-1 bg-clip-text font-default text-lg font-semibold text-transparent" style={{
                  backgroundImage: "linear-gradient(90deg, var(--chart-1), var(--chart-2))"
                }}>
                      {project.buildTime}
                    </div>
                  </div>
                  <div>
                    <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                      Impact Score
                    </div>
                    <div className="mt-1 bg-clip-text font-default text-lg font-semibold text-transparent" style={{
                  backgroundImage: "linear-gradient(90deg, var(--chart-2), var(--chart-3))"
                }}>
                      {project.pageSpeed}
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-lg opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
            boxShadow: "0 0 0 1px hsla(43, 65%, 35%, 0.25), 0 20px 60px -20px hsla(43, 65%, 35%, 0.35)"
          }} />
            </div>)}
        </div>

        {}
        <div className="mt-16 flex justify-center">
          <div className="rounded-lg p-[1.5px]" style={{
          backgroundImage: "linear-gradient(135deg, var(--chart-1), var(--chart-2))"
        }}>
            <Button asChild variant="ghost" size="lg" className="rounded-lg bg-background px-8 text-foreground hover:bg-accent">
              <Link to="/ResourcesPage">
                <span className="bg-clip-text font-medium text-transparent" style={{
                backgroundImage: "linear-gradient(90deg, var(--chart-1), var(--chart-2))"
              }}>
                  View All Success Stories
                </span>
                <ArrowUpRight className="ml-1 h-4 w-4" style={{
                color: "var(--chart-2)"
              }} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}